import { addSubscription } from '@/store/SubscriptionManager.ts'
import { getObservable } from '@/store/core/ObservableManager.ts'
import { addObservable } from '@/store/core/thunks/addObservable.ts'
import { setLoading } from '@/store/core/thunks/setLoading.ts'
import { initiateDataRefresh } from '@/store/initiateDataRefresh.ts'
import { LocalStorage } from '@/store/storage/LocalStorage.ts'
import type { Middleware } from '@reduxjs/toolkit'

import type { DefaultRootState } from '../coreReducer'
import type { IAppDispatch, ILocalStorage } from '../store'

const setupPersister = (dispatch: IAppDispatch, storage: ILocalStorage): void => {
	const observable = getObservable<DefaultRootState>('root')
	if (observable !== undefined) {
		console.debug('[booking-system:state]: Creating state subscription')
		addSubscription([
			observable.subscribe(stateToPersist => {
				console.debug('[booking-system:state]: Persisting state.')
				Promise.all(storage.persist(stateToPersist))
					.then(() => {
						console.debug(`[booking-system:state]: Successfully persisted encrypted state`, stateToPersist)
					})
					.catch((err: unknown) => {
						console.error('[booking-system:state]: Unable to persist encrypted state', err)
					})
			}),
		])
	}

	setTimeout(() => {
		console.log('dispatching initial data refresh')
		void dispatch(initiateDataRefresh())
	}, 500)
}

const subscriptionMiddleware =
	(storage: LocalStorage): Middleware<object, DefaultRootState> =>
	store =>
	next =>
	action => {
		const dispatch = store.dispatch as IAppDispatch
		const ne = next(action)

		if (addObservable.fulfilled.match(action)) {
			if (action.payload.some(i => i.type === 'root')) {
				setupPersister(dispatch, storage)
			}
		}

		// if (stateREHYDRATE.fulfilled.match(action)) {
		// }

		if (initiateDataRefresh.fulfilled.match(action)) {
			dispatch(setLoading(false))
		}

		return ne
	}

export { subscriptionMiddleware }
